import axios from "axios";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";

import About from "../../components/home/About";
import Banner from "../../components/home/Banner";
import Blog from "../../components/home/Blog";
import Event from "../../components/home/Event";
import EventBanner from "../../components/home/EventBanner";
import InquiryList from "../../components/home/InquiryList";
import Partners from "../../components/home/Partners";
import Service from "../../components/home/Service";
import Review from "../../components/home/Review";

const Home = () => {
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    axios.get("/api/blog").then((res) => {
      if (res.data.code === "0000") setData(res.data.data);
      else
        Swal.fire({
          title: "너무 많은 요청이 들어왔습니다. 다시 시도해주세요.",
          icon: "error",
        });
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <Banner />
      <About />
      <Service />
      <Event />
      <Blog data={data} />
      <EventBanner />
      <Review />
      <InquiryList />
      <Partners />
    </>
  );
};

export default Home;
